'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BinderLocatorWriterVisitor = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _QueryNodeVisitor2 = require('./QueryNodeVisitor');

var _QueryNodeVisitor3 = _interopRequireDefault(_QueryNodeVisitor2);

var _lodash = require('lodash');

var _BinderIdPredicate = require('./BinderIdPredicate');

var _BinderIdPredicate2 = _interopRequireDefault(_BinderIdPredicate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BinderLocatorWriterVisitor = exports.BinderLocatorWriterVisitor = function (_QueryNodeVisitor) {
    (0, _inherits3.default)(BinderLocatorWriterVisitor, _QueryNodeVisitor);

    function BinderLocatorWriterVisitor(rootNode) {
        (0, _classCallCheck3.default)(this, BinderLocatorWriterVisitor);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BinderLocatorWriterVisitor.__proto__ || (0, _getPrototypeOf2.default)(BinderLocatorWriterVisitor)).call(this));

        _this.queryNode = rootNode;
        _this.lastVisitedBinderId;
        return _this;
    }

    (0, _createClass3.default)(BinderLocatorWriterVisitor, [{
        key: 'visitBinderQuery',
        value: function visitBinderQuery(context) {
            this.lastVisitedBinderId = context.currentNode.binderId;
        }
    }, {
        key: 'visitDocumentTypePredicate',
        value: function visitDocumentTypePredicate(context) {
            context.skipData = true;
            context.skipChildren = true;

            var documentTypeNode = (0, _lodash.get)(this.queryNode, context.path);
            if (!documentTypeNode.parentNode.isRootFolder || BinderLocatorWriterVisitor.hasDescriptorDescendant(documentTypeNode)) {
                return;
            }
            var appliedBinderId = this.lastVisitedBinderId || context.appContext.binderId;
            if (documentTypeNode.children.some(function (child) {
                return child.type === 'BinderIdPredicate' && child.binderId === appliedBinderId;
            })) {
                //operation should be idempotent
                return;
            }
            var binderIdPredicateNode = new _BinderIdPredicate2.default({ data: { binderId: appliedBinderId } });
            documentTypeNode.addChild(binderIdPredicateNode);
        }
    }], [{
        key: 'hasDescriptorDescendant',
        value: function hasDescriptorDescendant(node) {
            var queue = [node];

            while (queue.length > 0) {
                var nextNode = queue.shift();
                if (nextNode.type === 'DescriptorPredicate') {
                    return true;
                }
                if (nextNode.canHaveChildren) {
                    queue.splice.apply(queue, [queue.length, 0].concat((0, _toConsumableArray3.default)(nextNode.children)));
                }
            }

            return false;
        }
    }]);
    return BinderLocatorWriterVisitor;
}(_QueryNodeVisitor3.default);

exports.default = BinderLocatorWriterVisitor;